import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DownloadService {

    constructor(private http: HttpClient) { }

    downloadFile(fileName: string) : Observable<Blob>
    {
        const url = "/assets/docs/" + fileName;
        return this.http.get(url, {responseType: 'blob'});
    }
}
